<template>
  <div id="grupo-procesos">
    <div Class="contratoTitulo">
      <v-container>
        <v-layout align-center>
          <v-flex xs12 md2>
            <label class="tipoContrato" style="width: 200px"
              >Tipo de Contrato</label
            >
          </v-flex>
          <v-flex xs12 md2>
            <v-select
              @change="cambioProceso"
              item-text="nombre"
              item-value="code"
              v-model="tipoCValue"
              :items="tipoCSelect"
              class="selectContrato"
            ></v-select>
          </v-flex>
          <v-flex xs12 md8> </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "grupoProcesos",
  components: {},
  props: {},
  data() {
    return {
      idContrato: 0,
      proceso: "",
      tipoCValue: "",
      tipoCSelect: [],
    };
  },
  computed: {},
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tipoCValue = "" + this.idContrato;
    //console.log("grupoContrato:" + this.idContrato + "::" + this.proceso);
    this.loadProcesos();
  },
  methods: {
    async loadProcesosGrupo() {
      return await axios
        .post("/procesosPorGrupo/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadProcesos() {
      this.loading = true;

      let resp = await this.loadProcesosGrupo();
      this.tipoCSelect = Object.entries(resp).map(([code, nombre]) => ({
        code,
        nombre,
      }));
      // console.log("st::this.tipoCSelect:" + JSON.stringify(this.tipoCSelect, null, 2));
      this.loading = false;
    },
    cambioProceso() {
      // console.log("Opción proceso:", this.tipoCValue);
      let id = this.tipoCValue;
      const selectedOption = this.tipoCSelect.find(
        (option) => option.code === id
      );
      let nuevoProceeso = selectedOption.nombre;
      // console.log("Opción seleccionadyyyyy:" + this.tipoCValue + "::" + selectedOption.nombre);
      this.$store.commit("contrato_state", id);
      this.$store.commit("pro_state", selectedOption.nombre);
      this.$store.commit("tab_state", "Proceso");
      if (nuevoProceeso == "IMPRESIÓN") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoImpresion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nuevoProceeso == "APLICACION") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoAplicacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nuevoProceeso == "CAPACITACION") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoCapacitacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nuevoProceeso == "CAPTURA") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoCaptura",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nuevoProceeso == "PREGUNTAS") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoPreguntas",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nuevoProceeso == "VALIDACIÓN") {
        this.setUsuRolInContract(id);
        this.$router.push({
          name: "ProcesoValidaciones",
          params: { contratoId: id, tipeView: "consulta" },
        });
      }
    },

    async setUsuRolInContract(id) {
      let user = await this.loadUsuarioData(id);
      if (user) {
        if (user.tipo == "ADMINISTRADOR") {
          this.$store.commit("rolInContract_state", {
            nombre: "Administrador",
          });
        } else {
          let rolesUsuario = this.getRol(user.lstUsuContratoRol);
          this.getUsuRolContrato(rolesUsuario);
        }
      }

      this.tipoRol = this.$store.getters.rolIncontractStored;
    },
    async loadUsuarioData(id) {
      if (this.userLogged) {
        return await axios
          .get("/user/" + this.userLogged + "/contrato/" + id)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
};
</script>
